// Add Card

export const ADD_CARD_REQUEST = 'ADD_CARD_REQUEST';
export const ADD_CARD_SUCCESS = 'ADD_CARD_SUCCESS';
export const ADD_CARD_FAIL = 'ADD_CARD_FAIL';
export const CLEAR_ADD_CARD_STATE = 'CLEAR_ADD_CARD_STATE';

// Update Card Status

export const UPDATE_CARD_REQUEST = 'UPDATE_CARD_REQUEST';
export const UPDATE_CARD_SUCCESS = 'UPDATE_CARD_SUCCESS';
export const UPDATE_CARD_FAIL = 'UPDATE_CARD_FAIL';
export const CLEAR_UPDATE_CARD_STATE = 'CLEAR_UPDATE_CARD_STATE';

// Get Cards

export const GET_CARD_REQUEST = 'GET_CARD_REQUEST';
export const GET_CARD_SUCCESS = 'GET_CARD_SUCCESS';
export const GET_CARD_FAIL = 'GET_CARD_FAIL';
export const CLEAR_GET_CARD_STATES = 'CLEAR_GET_CARD_STATES';
